import { Component, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { ContentTheme } from '../../models';

@Component({
  selector: 'wl-partial-structured-content',
  templateUrl: './structured-content.component.html',
  styleUrls: ['./structured-content.component.ed.scss'],
  standalone: true,
  imports: [FaIconComponent],
})
export class StructuredContentComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() theme: ContentTheme = 'default';

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() icon?: IconProp;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() heading?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() subheading?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() paragraph?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() layoutButtonsInline = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() centered = false;
}
